import { jsx } from '@emotion/react';
import { ProgressBar } from '@zapier/design-system';
import { labelStyles } from '@zapier/style-encapsulation';
import { abbreviateNumber } from './abbreviateNumber';
import { baseReset, boxSizing } from '../../../../../utils/style-mixins/reset';
const Styles = labelStyles('UsageBar', {
    root: Object.assign(Object.assign({}, baseReset), { display: 'block', 'div > div': {
            backgroundColor: 'var(--zds-ui-primary, #847DFE)',
        } }),
    text: Object.assign(Object.assign({}, baseReset), { display: 'grid', gap: 20, gridTemplateColumns: 'auto 1fr', marginBottom: 'var(--zds-space-4, 4px)' }),
    label: Object.assign(Object.assign({}, boxSizing), { font: `var(--zds-minimal-print-1)`, color: 'var(--zds-text-weaker, #574E4C)' }),
    amounts: Object.assign(Object.assign({}, boxSizing), { font: `var(--zds-minimal-print-2)`, textAlign: 'right', color: 'var(--zds-text-default, #413735)' }),
});
const formatNumber = (number) => {
    const formatted = number > 9999 ? abbreviateNumber(number) : number.toLocaleString();
    return typeof formatted === 'string' ? formatted : 'Error';
};
const UsageBar = (props) => {
    const amount = props.max === Infinity
        ? 'Unlimited'
        : `${formatNumber(props.value)} / ${formatNumber(props.max)}`;
    return (jsx("figure", { css: Styles.root, "data-zds": true },
        jsx("p", { css: Styles.text, "data-zds": true },
            jsx("span", { "aria-hidden": true, css: Styles.label, "data-zds": true }, props.label),
            jsx("span", { "aria-hidden": true, css: Styles.amounts, "data-zds": true }, amount)),
        props.max !== Infinity && (jsx(ProgressBar, { max: props.max, value: props.value }))));
};
export default UsageBar;
//# sourceMappingURL=UsageBar.js.map
// @zapier/universal-layout@11.0.60 (de4647366)
